import { heroHighlights } from "@/mocks/siteData";

export default function Hero() {
  const jump = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="top"
      className="relative overflow-hidden pt-28 pb-16 md:pt-36 md:pb-24 bg-background-50"
    >
      <div
        className="pointer-events-none absolute -top-24 -left-24 w-[420px] h-[420px] rounded-full bg-primary-100/60 blur-3xl"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute top-40 right-0 w-[360px] h-[360px] rounded-full bg-accent-100/70 blur-3xl"
        aria-hidden="true"
      />

      <div className="relative w-full px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 items-center">
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs md:text-sm font-label">
              <i className="ri-bookmark-3-fill" />
              官网入口 · 最新地址 · 访问指南
            </span>

            <h1 className="mt-5 text-3xl md:text-5xl font-heading font-black text-foreground-950 leading-tight md:leading-[1.15]">
              蓝莓视频官网入口与最新地址访问指南
            </h1>

            <p className="mt-5 text-base md:text-lg leading-relaxed text-foreground-600 max-w-2xl">
              本页汇总<span className="text-foreground-900 font-medium">蓝莓视频官网入口</span>、最新地址与首页访问方法，解决找不到平台的困扰。无论你是想看视频还是找资源，都可以在这里快速获得有效链接，并学会避开虚假站点。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <button
                type="button"
                onClick={() => jump("access")}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-label font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                查看完整访问流程
                <i className="ri-arrow-right-line" />
              </button>
              <button
                type="button"
                onClick={() => jump("latest")}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-300 bg-background-50 text-foreground-900 text-sm md:text-base font-label font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-map-pin-time-line text-accent-600" />
                获取最新地址方法
              </button>
            </div>

            <p className="mt-5 text-xs md:text-sm text-foreground-500 flex items-center gap-2">
              <i className="ri-information-line" />
              本页为信息导航与访问方法说明，内容仅供查阅参考。
            </p>
          </div>

          <div className="lg:col-span-5">
            <div className="relative w-full h-[240px] sm:h-[320px] lg:h-[420px] rounded-2xl overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20of%20flowing%20warm%20crimson%20and%20golden%20amber%20silk%20ribbons%20against%20a%20soft%20cream%20background%2C%20cinematic%20light%20and%20shadow%2C%20elegant%20editorial%20visual%2C%20smooth%20organic%20curves%2C%20high%20detail%2C%20harmonious%20warm%20palette&width=900&height=1100&seq=blueberry-hero-01&orientation=portrait"
                alt="暖色调抽象视觉，象征蓝莓视频频道与内容流转"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/45 via-foreground-950/5 to-transparent" />
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-50/90 text-primary-600">
                  <i className="ri-play-circle-line text-xl" />
                </span>
                <p className="text-background-50 text-sm font-label leading-snug">
                  一页看懂：从哪里进、怎么找、如何辨别真假
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-3 gap-4">
          {heroHighlights.map((item) => (
            <div
              key={item.title}
              className="p-5 rounded-xl bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className={`${item.icon} text-xl`} />
              </span>
              <h3 className="mt-4 text-base font-heading font-bold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}